<template>
  <div class="service">
    <picture>
      <source
        media="(max-width: 767px)"
        srcset="~@/assets/images/about-mobile.png 767w"
      />
      <img class="service-banner" src="~@/assets/images/about.jpg" />
    </picture>
    <Title />
    <ServicePage1
      v-if="page === '1'"
      ref="light"
      @getOrderStatus="getOrderStatus"
    />
    <ServicePage2
      v-if="page === '2'"
      ref="repose"
      @getOrderStatus="getOrderStatus"
    />
    <ServicePage3 v-if="page === '3'" />
    <div class="footer-clear" />
  </div>
</template>

<script>
import store from 'Store/store';
import Title from 'Pages/MainModule/Title.vue';
import ServicePage1 from 'Pages/ServiceModule/ServicePage1.vue';
import ServicePage2 from 'Pages/ServiceModule/ServicePage2.vue';
import ServicePage3 from 'Pages/ServiceModule/ServicePage3.vue';

export default {
  name: 'Service',
  data() {
    return {
      page: this.$route.query.page,
    };
  },
  components: {
    Title,
    ServicePage1,
    ServicePage2,
    ServicePage3,
  },
  methods: {
    getOrderStatus() {
      let orderInfo = decodeURI(this.$route.query.data);
      if (orderInfo != 'undefined' && orderInfo != '') {
        let getOrderStatusRequest = { param: orderInfo };
        store.dispatch('main/getOrderStatus', getOrderStatusRequest);
        this.$router.replace('/service?page=' + this.page);
      }
    },
  },
  computed: {
    orderStatus() {
      return store.state.main.orderStatus;
    },
  },
  watch: {
    $route() {
      this.page = this.$route.query.page;
    },
    orderStatus() {
      if (this.orderStatus !== undefined && this.orderStatus !== '') {
        if (this.page == 1) {
          this.$refs.light.showResult();
        } else {
          this.$refs.repose.showResult();
        }
      }
    },
  },
};
</script>

<style scoped>
.service {
  text-align: left;
}
.service-banner {
  width: 100%;
  vertical-align: top;
}
.service > div {
  margin: 20px 20% 0 20%;
}
.footer-clear {
  height: 150px;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(24px, 0);
  }
}
@media (max-width: 767px) {
  .service-banner {
    margin-top: 10px;
  }
  .service > div {
    margin: 0 20px;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .service > div {
    margin: 20px 10% 0 10%;
  }
}
</style>
